import { render, staticRenderFns } from "./LicenceCards.vue?vue&type=template&id=1d1125d5&"
import script from "./LicenceCards.vue?vue&type=script&lang=js&"
export * from "./LicenceCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports